import { API_HOST } from './config';
import { poller } from './lib/poller';
import { paymentForm } from './methods/payment-form';
import { applePay } from './methods/apple-pay';
import { bindAppleTokenV2 } from './methods/bind-apple-token-v2';
import { bindCard } from './methods/bind-card';
import { bindCardV2 } from './methods/bind-card-v2';
import { bindSbpToken } from './methods/bind-sbp-token';
import { listenPayment } from './methods/listen-payment';
import { loadCards } from './methods/load-cards';
import { getDomainSfx } from './utils/common';
export { isCard, isSbpToken } from './utils/common';
var TrustSDK = (function () {
    function TrustSDK(options) {
        if (options === void 0) { options = {}; }
        this.apiHost = API_HOST;
        this.frameOrigin = '*';
        if (options.apiHost) {
            this.apiHost = options.apiHost;
        }
        if (options.frameOrigin) {
            this.frameOrigin = options.frameOrigin;
        }
        if (!this.apiHost.endsWith(".".concat(getDomainSfx()))) {
            console.warn('Mismatch parent and API domainSfx');
        }
    }
    TrustSDK.create = function (options) {
        return new TrustSDK(options);
    };
    TrustSDK.prototype.loadCards = function (options) {
        if (options === void 0) { options = {}; }
        return loadCards(this.apiHost, options);
    };
    TrustSDK.prototype.paymentForm = function (options) {
        return paymentForm(this.apiHost, options);
    };
    TrustSDK.prototype.bindCard = function (options) {
        var _this = this;
        var _a;
        if (options === void 0) { options = {}; }
        var formPromise = bindCard(this.apiHost, options);
        if (!((_a = options.polling) === null || _a === void 0 ? void 0 : _a.enable)) {
            return formPromise;
        }
        return formPromise.then(function (form) {
            return form.on('success', function (res) {
                var poll = poller(options.polling);
                poll(function () {
                    return _this.loadCards()
                        .then(function (cards) { return cards.some(function (card) { return card.id === res.cardId; }); });
                })
                    .then(function () {
                    form.emit('success-ensure-card-binding', res);
                })
                    .catch(function (err) {
                    form.emit('fail-ensure-card-binding', err);
                });
            });
        });
    };
    TrustSDK.prototype.bindCardV2 = function (options) {
        var formPromise = bindCardV2(this.apiHost, options);
        return formPromise.then(function (form) {
            return form.on('success', function (res) {
                form.emit('success-ensure-card-binding', res);
            });
        });
    };
    TrustSDK.prototype.bindAppleTokenV2 = function (options) {
        var formPromise = bindAppleTokenV2(this.apiHost, options);
        return formPromise.then(function (form) {
            return form.on('success', function (res) {
                form.emit('success-ensure-card-binding', res);
            });
        });
    };
    TrustSDK.prototype.bindSbpToken = function (options) {
        return bindSbpToken(this.apiHost, options);
    };
    TrustSDK.prototype.listenPayment = function (onMessage) {
        return listenPayment(onMessage);
    };
    TrustSDK.prototype.applePay = function () {
        return applePay({
            apiHost: this.apiHost,
            frameOrigin: this.frameOrigin
        });
    };
    return TrustSDK;
}());
export default TrustSDK;
